import PropTypes from 'prop-types'
import React from 'react'

class Select extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (event) {
    const value = event.currentTarget.value
    this.props.onChange(event, value)
  }

  renderSelect () {
    return (
      <select
        name={this.props.name}
        onChange={this.handleChange}
        defaultValue={this.props.value}
        style={{
          cursor: 'pointer',
          background: 'white',
          borderRadius: '0.27em',
          border: '0.055em solid #e6e6e6',
          padding: '0.55em',
          boxSizing: 'border-box'
        }}
      >
        {this.props.children}
      </select>
    )
  }

  renderPlaceholder () {
    const { placeholder } = this.props
    if (!placeholder) {
      return
    }
    return (
      <div
        style={{
          textAlign: 'left',
          textTransform: 'uppercase',
          fontWeight: 'bold',
          fontSize: '0.77em'
        }}
      >
        {placeholder}
      </div>
    )
  }

  render () {
    return (
      <div
        style={{

          ...(this.props.style || {})
        }}
      >
        {this.renderPlaceholder()}
        {this.renderSelect()}
      </div>
    )
  }
}

Select.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default Select
